import { observable, runInAction } from 'mobx';

import { Reference } from 'app/model/Reference';
import { ReferenceService } from 'app/service/ReferenceService';

export class LocalityTypeStore {
    private readonly referenceService: ReferenceService =
        new ReferenceService();

    @observable
    private localityTypes?: Array<Reference>;

    getById = (id: string): Reference => {
        return this.localityTypes?.find(
            (localityType) => localityType.id === id,
        );
    };

    initialize = (): Promise<any> => {
        return this.referenceService
            .getLocalityTypesReference()
            .then((localityTypes) => {
                runInAction(() => {
                    this.localityTypes = localityTypes;
                });
            });
    };
}
